  (function() {
      'use strict';

      const videoStates = new WeakMap();
      let globalMuted = true;

      function initVideoCarousel() {
        const wrappers = document.querySelectorAll('.video-carousel-wrapper');

        wrappers.forEach(wrapper => {
          const trackContainer = wrapper.querySelector('.video-carousel-track-container');
          const track = wrapper.querySelector('.video-carousel-track');
          const leftArrow = wrapper.querySelector('.carousel-arrow-left');
          const rightArrow = wrapper.querySelector('.carousel-arrow-right');

          let items = Array.from(track.querySelectorAll('.video-item'));
          if (items.length === 0) return;

          let focusedIndex = Math.floor(items.length / 2);

          // Touch only (mobile)
          let isDragging = false;
          let initialX = 0;
          let startTransformX = 0;
          let currentTransformX = 0;
          let dragThreshold = 50;
          let rafId = null;
          let isAnimating = false;

          updateFocus();
          setTimeout(() => centerFocusedItem(false), 200);

          leftArrow.addEventListener('click', () => goToPrev());
          rightArrow.addEventListener('click', () => goToNext());

          function goToNext() {
            if (isAnimating) return;
            isAnimating = true;

            const itemToMove = items[0];
            itemToMove.style.transition = 'opacity 0.3s ease-out';
            itemToMove.style.opacity = '0';

            focusedIndex++;
            if (focusedIndex >= items.length) focusedIndex = items.length - 1;

            updateFocus();
            centerFocusedItem(true);

            setTimeout(() => {
              reorderForward(itemToMove);
            }, 500);
          }

          function goToPrev() {
            if (isAnimating) return;
            isAnimating = true;

            const itemToMove = items[items.length - 1];
            itemToMove.style.transition = 'opacity 0.3s ease-out';
            itemToMove.style.opacity = '0';

            focusedIndex--;
            if (focusedIndex < 0) focusedIndex = 0;

            updateFocus();
            centerFocusedItem(true);

            setTimeout(() => {
              reorderBackward(itemToMove);
            }, 500);
          }

          function reorderForward(itemToMove) {
            track.style.transition = 'none';

            const currentX = getTransformX(track);
            const itemWidth = itemToMove.offsetWidth + 20;

            track.appendChild(itemToMove);
            items = Array.from(track.querySelectorAll('.video-item'));
            focusedIndex--;
            if (focusedIndex < 0) focusedIndex = 0;

            track.style.transform = `translateX(${currentX + itemWidth}px)`;

            void track.offsetHeight;

            requestAnimationFrame(() => {
              track.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

              requestAnimationFrame(() => {
                itemToMove.style.transition = 'opacity 0.4s ease-in';
                itemToMove.style.opacity = '';

                setTimeout(() => {
                  itemToMove.style.transition = '';
                  isAnimating = false;
                }, 400);
              });
            });
          }

          function reorderBackward(itemToMove) {
            track.style.transition = 'none';

            const currentX = getTransformX(track);
            const itemWidth = itemToMove.offsetWidth + 20;

            track.insertBefore(itemToMove, items[0]);
            items = Array.from(track.querySelectorAll('.video-item'));
            focusedIndex++;
            if (focusedIndex >= items.length) focusedIndex = items.length - 1;

            track.style.transform = `translateX(${currentX - itemWidth}px)`;

            void track.offsetHeight;

            requestAnimationFrame(() => {
              track.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

              requestAnimationFrame(() => {
                itemToMove.style.transition = 'opacity 0.4s ease-in';
                itemToMove.style.opacity = '';

                setTimeout(() => {
                  itemToMove.style.transition = '';
                  isAnimating = false;
                }, 400);
              });
            });
          }

          function centerFocusedItem(animate = true) {
            const wrapperRect = wrapper.getBoundingClientRect();
            const wrapperCenter = wrapperRect.width / 2;

            const focusedItem = items[focusedIndex];
            if (!focusedItem) return;

            if (!animate) {
              track.style.transition = 'none';
            } else {
              track.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';
            }

            const focusedRect = focusedItem.getBoundingClientRect();
            const currentX = getTransformX(track);
            const focusedCenter = focusedRect.left - wrapperRect.left + (focusedRect.width / 2);
            const offset = wrapperCenter - focusedCenter;

            track.style.transform = `translateX(${currentX + offset}px)`;

            if (!animate) {
              void track.offsetHeight;
              track.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';
            }
          }

          function updateFocus() {
            items.forEach((item, index) => {
              const video = item.querySelector('video');

              if (index === focusedIndex) {
                item.classList.add('is-focused');
                if (video) {
                  video.muted = globalMuted;
                  item.classList.toggle('has-sound', !globalMuted);
                  setTimeout(() => safeVideoPlay(video, item), 400);
                }
              } else {
                item.classList.remove('is-focused');
                item.classList.remove('has-sound');
                if (video && !video.paused) {
                  video.pause();
                  video.muted = true;
                  item.classList.remove('is-playing');
                }
              }
            });
          }

          // Touch events (mobile only)
          trackContainer.addEventListener('touchstart', (e) => {
            if (isAnimating) return;
            isDragging = true;
            initialX = e.touches[0].clientX;
            startTransformX = getTransformX(track);
            track.style.transition = 'none';
          }, { passive: true });

          trackContainer.addEventListener('touchmove', (e) => {
            if (!isDragging) return;
            const diff = e.touches[0].clientX - initialX;
            currentTransformX = startTransformX + diff;
            rafId = requestAnimationFrame(() => {
              track.style.transform = `translateX(${currentTransformX}px)`;
            });
          }, { passive: true });

          trackContainer.addEventListener('touchend', (e) => {
            if (!isDragging) return;
            isDragging = false;
            track.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

            const totalDiff = e.changedTouches[0].clientX - initialX;
            if (totalDiff > dragThreshold) {
              goToPrev();
            } else if (totalDiff < -dragThreshold) {
              goToNext();
            } else {
              centerFocusedItem(true);
            }
          });

          // Click handlers for video items
          items.forEach((item) => {
            setupItemClickHandler(item);
          });

          function setupItemClickHandler(item) {
            const video = item.querySelector('video');
            const playBtn = item.querySelector('.play-pause-btn');
            const soundBtn = item.querySelector('.sound-btn');

            if (video) {
              videoStates.set(video, { isTransitioning: false });
              video.preload = 'auto';
            }

            if (playBtn) {
              playBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (video) toggleVideo(video, item);
              });
            }

            if (soundBtn) {
              soundBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (video) toggleSound(video, item);
              });
            }

            item.addEventListener('click', (e) => {
              if (e.target.closest('.play-pause-btn') ||
                  e.target.closest('.sound-btn') ||
                  e.target.closest('.video-link-btn')) return;

              const currentItems = Array.from(track.querySelectorAll('.video-item'));
              const clickedIndex = currentItems.indexOf(item);

              if (clickedIndex < focusedIndex) {
                goToPrev();
              } else if (clickedIndex > focusedIndex) {
                goToNext();
              } else if (video) {
                toggleVideo(video, item);
              }
            });
          }

          window.addEventListener('resize', () => centerFocusedItem(false));

          wrapper.setAttribute('tabindex', '0');
          wrapper.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') goToPrev();
            else if (e.key === 'ArrowRight') goToNext();
          });
        });
      }

      function getTransformX(element) {
        const matrix = window.getComputedStyle(element).transform;
        if (matrix === 'none') return 0;
        const values = matrix.match(/matrix.*\((.+)\)/);
        return values ? parseFloat(values[1].split(', ')[4]) || 0 : 0;
      }

      function toggleSound(video, item) {
        video.muted = !video.muted;
        globalMuted = video.muted;
        item.classList.toggle('has-sound', !video.muted);
      }

      function safeVideoPlay(video, item) {
        const state = videoStates.get(video);
        if (!state || state.isTransitioning) return;

        state.isTransitioning = true;
        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              item.classList.add('is-playing');
              state.isTransitioning = false;
            })
            .catch(() => {
              item.classList.remove('is-playing');
              state.isTransitioning = false;
            });
        } else {
          item.classList.add('is-playing');
          state.isTransitioning = false;
        }
      }

      function safeVideoPause(video, item) {
        const state = videoStates.get(video);
        if (!state || state.isTransitioning) return;
        video.pause();
        item.classList.remove('is-playing');
      }

      function toggleVideo(video, item) {
        const state = videoStates.get(video);
        if (state && state.isTransitioning) return;

        document.querySelectorAll('.video-carousel-track .video-item').forEach(otherItem => {
          if (otherItem !== item) {
            const otherVideo = otherItem.querySelector('video');
            if (otherVideo && !otherVideo.paused) {
              safeVideoPause(otherVideo, otherItem);
            }
          }
        });

        if (video.paused) {
          safeVideoPlay(video, item);
        } else {
          safeVideoPause(video, item);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoCarousel);
      } else {
        initVideoCarousel();
      }
  })();